<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <div class="input-group-text">
        <i class="far fa-calendar"></i>
      </div>
    </div>

    <input :id="id" type="text" class="form-control datepicker" autocomplete="off" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tracker() {
      return this.$store.getters.getChangeTracker;
    }
  },

  data() {
    return {
      // date: "",
      test: "",
      option: null
    };
  },

  watch: {
    date: function(val) {
      // console.log($('#'+this.id).data('daterangepicker'));
      // this.$emit("input", val);
      // console.log(this.input)
    },
    value: function(val) {
      if (val) {
        // console.log(val);
        $("#" + this.id).val(val);
        this.initDatepicker();
        this.$emit("input", val);
        // $("#" + this.id)
        //   .data("daterangepicker")
        //   .setStartDate(val);
      } else {
        $("#" + this.id).val("");
        this.$emit("input", "");
      }
    }
  },
  mounted() {
    let $vm = this;
    if (this.value) {
      $("#" + this.id).val(this.value);
    }
    this.$nextTick(() => {
      $("#" + this.id).focus(() => {
        this.$emit("clickEvent", "");
      });

      $("#" + this.id).on("input", () => {
        this.$emit("input", $("#" + this.id).val());
      });

      this.initDatepicker();
    });
  },
  methods: {
    initDatepicker() {
      let $vm = this;
      if (jQuery().daterangepicker) {
        if ($("#" + this.id).length) {
          $("#" + this.id)
            .daterangepicker({
              locale: {
                format: "YYYY-MM-DD"
              },
              autoApply: true,
              singleDatePicker: true,
              autoUpdateInput: false,
              minDate: "2000-01-01",
              showDropdowns: true,
              maxDate: `${parseInt(moment().format("YYYY"), 10)}-12-31`
            })
            .on("apply.daterangepicker", function(e, picker) {
              let date = picker.startDate.format(picker.locale.format);
              $("#" + this.id).val(date);
              $vm.$emit("input", date);
            })
            .on("hide.daterangepicker", function(e, picker) {});
        }
      }
    }
  }
};
</script>